import _ from 'lodash';
import i18n from './i18n';

export const WEEK_DAYS_FROM_SUNDAY = [
  {
    name: i18n.t('weekDays.sunday.NAME'),
    shortName: i18n.t('weekDays.sunday.SHORT_NAME'),
    index: 0
  },
  {
    name: i18n.t('weekDays.monday.NAME'),
    shortName: i18n.t('weekDays.monday.SHORT_NAME'),
    index: 1
  },
  {
    name: i18n.t('weekDays.tuesday.NAME'),
    shortName: i18n.t('weekDays.tuesday.SHORT_NAME'),
    index: 2
  },
  {
    name: i18n.t('weekDays.wednesday.NAME'),
    shortName: i18n.t('weekDays.wednesday.SHORT_NAME'),
    index: 3
  },
  {
    name: i18n.t('weekDays.thursday.NAME'),
    shortName: i18n.t('weekDays.thursday.SHORT_NAME'),
    index: 4
  },
  {
    name: i18n.t('weekDays.friday.NAME'),
    shortName: i18n.t('weekDays.friday.SHORT_NAME'),
    index: 5
  },
  {
    name: i18n.t('weekDays.saturday.NAME'),
    shortName: i18n.t('weekDays.saturday.SHORT_NAME'),
    index: 6
  }
];

export const MONTHS = [
  i18n.t('months.JANUARY'),
  i18n.t('months.FEBRUARY'),
  i18n.t('months.MARCH'),
  i18n.t('months.APRIL'),
  i18n.t('months.MAY'),
  i18n.t('months.JUNE'),
  i18n.t('months.JULY'),
  i18n.t('months.AUGUST'),
  i18n.t('months.SEPTEMBER'),
  i18n.t('months.OCTOBER'),
  i18n.t('months.NOVEMBER'),
  i18n.t('months.DECEMBER')
];

export const appRateStatuses = {
  NOT_PROMPTED: 'NOT_PROMPTED',
  DISMISSED: 'DISMISSED',
  VOTED: 'VOTED'
};

export const bookingSessionEventStatuses = {
  BOOKING: 'BOOKING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  STARTED: 'STARTED'
};

export const SHOW_APP_RATE_AFTER_DAYS = 14;

function weekDaysFromMonday() {
  const startWeekDaysWithMonday = _.clone(WEEK_DAYS_FROM_SUNDAY);
  startWeekDaysWithMonday.push(startWeekDaysWithMonday.shift());
  return startWeekDaysWithMonday;
}

export const WEEK_DAYS_FROM_MONDAY = weekDaysFromMonday();

export const loginErrors = {
  LOGIN_NO_EMAIL_CONFIRMATION: 'LOGIN_NO_EMAIL_CONFIRMATION',
  LOGIN_NO_VERIFICATION: 'LOGIN_NO_VERIFICATION'
};

export const utmParams = [
  'utm_source',
  'utm_medium',
  'utm_term',
  'utm_campaign',
  'utm_content'
];

export const gender = [
  {
    value: 'Male',
    label: 'Male'
  },
  {
    value: 'Female',
    label: 'Female'
  },
  {
    value: 'Other',
    label: 'Other'
  },
  {
    value: 'Prefer not to say',
    label: 'Prefer not to say'
  }
];

export const bookingLimitReason = {
  WEEKLY_PLAYER_LIMIT: 'WEEKLY_PLAYER_LIMIT',
  EVENT_SPACE_LIMIT: 'EVENT_SPACE_LIMIT'
};

export const modals = {
  NONE: 'NONE',
  BOOKING_SESSION_COMPLETE: 'BOOKING_SESSION_COMPLETE',
  BOOKING_SESSION_FAILURE: 'BOOKING_SESSION_FAILURE',
  BOOKING_COURT_COMPLETE: 'BOOKING_COURT_COMPLETE',
  BOOKING_COURT_FAILURE: 'BOOKING_COURT_FAILURE',
  APP_RATE: 'APP_RATE',
  WELCOME: 'WELCOME',
  THANK_YOU_FOR_HELP: 'THANK_YOU_FOR_HELP',
  INVITE_FRIENDS_TO_SESSION_BOOKING: 'INVITE_FRIENDS_TO_SESSION_BOOKING',
  INVITE_FRIENDS_TO_COURT_BOOKING: 'INVITE_FRIENDS_TO_COURT_BOOKING',
  SEND_FEEDBACK: 'SEND_FEEDBACK',
  FEEDBACK_SENT: 'FEEDBACK_SENT',
  LEARN_ABOUT_PREMIUM: 'LEARN_ABOUT_PREMIUM',
  EMERGENCY_CONTACT: 'EMERGENCY_CONTACT',
  CANCELLATION_CONFIRM: 'CANCELLATION_CONFIRM',
  CANCELLATION_RESULT: 'CANCELLATION_RESULT',
  PAYMENT_SUCCESS: 'PAYMENT_SUCCESS',
  UPDATE_CARD_SUCCESS: 'UPDATE_CARD_SUCCESS',
  CANCEL_PREMIUM_MODAL: 'CANCEL_PREMIUM_MODAL',
  CANCEL_PREMIUM_SUCCESS_MODAL: 'CANCEL_PREMIUM_SUCCESS_MODAL',
  NO_TRIAL_WARNING_MODAL: 'NO_TRIAL_WARNING_MODAL',
  START_RESETING_PASSWORD_SUCCESS: 'START_RESETING_PASSWORD_SUCCESS',
  CONFIRM_RESETTING_PASSWORD_SUCCESS: 'CONFIRM_RESETTING_PASSWORD_SUCCESS'
};

export const SINGLE_SESSION = 'SINGLE_SESSION';
export const UPCOMING_EVENTS = 'UPCOMING_EVENTS';
export const USER_BOOKED_EVENTS = 'USER_BOOKED_EVENTS';
export const GET_VENUE_AREAS = 'GET_VENUE_AREAS';
export const COURTS = 'COURTS';

export const endRouteActionsTypes = {
  PENDING_SESSION_BOOKING: 'SESSION_BOOKING',
  PENDING_COURT_BOOKING: 'COURT_BOOKING'
};

export const bookingLimitReasons = {
  EVENT_COURT_LIMIT: 'EVENT_COURT_LIMIT',
  EVENT_PLAYER_LIMIT: 'EVENT_PLAYER_LIMIT',
  PLAYER_WEEKLY_LIMIT: 'PLAYER_WEEKLY_LIMIT'
};

export const courtsFiltersModes = {
  PART: 'PART',
  FULL: 'FULL'
};

export const fullStoryOrg = 'CPYMX';
export const courtBookingOptions = {
  SINGLE_INVITE_VALUE: 1,
  DOUBLES_INVITE_VALUE: 3
};

export const courtSizeTypes = {
  SINGLE: 'SINGLE',
  DOUBLE: 'DOUBLE'
};

export const idsNames = {
  SESSION_ID_PREFIX: 'session-',
  COURT_ID_PREFIC: 'court-'
};

export const subscriptionStatuses = {
  NO_VALID_SUBSCRIPTION: 'NO_VALID_SUBSCRIPTION',
  TRIAL: 'TRIAL',
  ACTIVE: 'ACTIVE',
  UNPAID: 'UNPAID',
  EXPIRING: 'EXPIRING'
};

export const paymentStatuses = {
  START: 'START',
  STRIPE_CHECKOUT: 'STRIPE_CHECKOUT',
  STRIPE_CHECKOUT_FAILED: 'STRIPE_CHECKOUT_FAILED',
  PROCESS_PAYMENT: 'PROCESS_PAYMENT',
  PROCESSING_IN_PROGRESS: 'PROCESSING_IN_PROGRESS',
  PAYMENT_FAILED: 'PAYMENT_FAILED'
};

export const bookingErrorType = 'BOOKING_OPERATION';

export const bookingOperationErrorSubtypesMessages = {
  NON_AUTHORIZED_USER: i18n.t('errorSubtypesMessages.NON_AUTHORIZED_USER'),
  NO_VALID_SUBSCRIPTION: i18n.t('errorSubtypesMessages.NO_VALID_SUBSCRIPTION'),
  EVENT_ALREADY_BOOKED: i18n.t('errorSubtypesMessages.EVENT_ALREADY_BOOKED'),
  WEEKLY_LIMIT_REACHED: i18n.t('errorSubtypesMessages.WEEKLY_LIMIT_REACHED'),
  DAILY_LIMIT_REACHED: i18n.t('errorSubtypesMessages.DAILY_LIMIT_REACHED'),
  CANCELED_EVENT: i18n.t('errorSubtypesMessages.CANCELLED_EVENT'),
  EVENT_IN_PAST: i18n.t('errorSubtypesMessages.EVENT_IN_PAST'),
  FULLY_BOOKED: i18n.t('errorSubtypesMessages.FULLY_BOOKED')
};

export const bookingAvailabilityStatuses = {
  AVAILABLE: 'AVAILABLE',
  NON_AUTHORIZED_USER: 'NON_AUTHORIZED_USER',
  NO_VALID_SUBSCRIPTION: 'NO_VALID_SUBSCRIPTION',
  EVENT_ALREADY_BOOKED: 'EVENT_ALREADY_BOOKED',
  WEEKLY_LIMIT_REACHED: 'WEEKLY_LIMIT_REACHED',
  DAILY_LIMIT_REACHED: 'DAILY_LIMIT_REACHED',
  CANCELED_EVENT: 'CANCELED_EVENT',
  EVENT_IN_PAST: 'EVENT_IN_PAST',
  FULLY_BOOKED: 'FULLY_BOOKED'
};

export const bookingAvailabilityStatusesMessages = {
  NON_AUTHORIZED_USER: i18n.t(
    'bookingAvailabilityStatusesMessages.NON_AUTHORIZED_USER'
  ),
  NO_VALID_SUBSCRIPTION: i18n.t(
    'bookingAvailabilityStatusesMessages.NO_VALID_SUBSCRIPTION'
  ),
  EVENT_ALREADY_BOOKED: i18n.t(
    'bookingAvailabilityStatusesMessages.EVENT_ALREADY_BOOKED'
  ),
  WEEKLY_LIMIT_REACHED: i18n.t(
    'bookingAvailabilityStatusesMessages.WEEKLY_LIMIT_REACHED'
  ),
  DAILY_LIMIT_REACHED: i18n.t(
    'bookingAvailabilityStatusesMessages.DAILY_LIMIT_REACHED'
  ),
  CANCELED_EVENT: i18n.t('bookingAvailabilityStatusesMessages.CANCELLED_EVENT'),
  EVENT_IN_PAST: i18n.t('bookingAvailabilityStatusesMessages.EVENT_IN_PAST'),
  FULLY_BOOKED: i18n.t('bookingAvailabilityStatusesMessages.FULLY_BOOKED')
};

export const disableBookStatuses = [
  bookingAvailabilityStatuses.EVENT_ALREADY_BOOKED,
  bookingAvailabilityStatuses.WEEKLY_LIMIT_REACHED,
  bookingAvailabilityStatuses.DAILY_LIMIT_REACHED,
  bookingAvailabilityStatuses.CANCELED_EVENT,
  bookingAvailabilityStatuses.EVENT_IN_PAST,
  bookingAvailabilityStatuses.FULLY_BOOKED
];

export const MIN_PASSWORD_LENGTH = 8;



// WEBPACK FOOTER //
// ./src/utils/constants.js